/**
 * Checks if the given text contains Chinese characters.
 *
 * @param {string} text The text to check.
 *
 * @returns {boolean} True if the text contains Chinese characters, false otherwise.
 */
export default function isChineseText(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }

  // Chinese character range in Unicode
  const chineseCharRegex = /[\u4e00-\u9fff]/;

  return chineseCharRegex.test(text);
}
